export const inputStyle = {
  label: 'group-data-[filled-within=true]:text-gray-400',
  input: 'placeholder:text-chLightText',
  inputWrapper: 'bg-chOffWhite border-1 data-[hover=true]:bg-chOffWhite-200'
}

export const textAreaStyle = {
  label: 'group-data-[filled-within=true]:text-gray-400',
  input: 'placeholder:text-chLightText text-md',
  inputWrapper: 'bg-chOffWhite border-1 data-[hover=true]:bg-chOffWhite-200'
}

export const menuContainerClass = 'grid grid-cols-1 md:grid-cols-2 gap-2 bg-chLight rounded-md p-2'
export const menuItemClasses = {
  separator: 'pl pr md:pl-2 md:pr-2',
  item: 'data-[current=false]:text-info hover:text-primary data-[current=true]:text-secondary data-[current=true]:font-bold'
}